module.exports = __webpack_public_path__ + "img/give-like.500221da.png";